import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Layout } from "@/components/Layout";
import { HomePage } from "@/pages/HomePage";
import { TutorialPage } from "@/pages/TutorialPage";
import { BookmarksPage } from "@/pages/BookmarksPage";
import { LoginPage } from "@/pages/LoginPage";
import { RequireAuth } from "@/components/RequireAuth";

const openSearch = () => window.dispatchEvent(new CustomEvent("cms:open-search"));

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            element={
              <RequireAuth>
                <Layout />
              </RequireAuth>
            }
          >
            <Route path="/" element={<HomePage onOpenSearch={openSearch} />} />
            <Route path="/tutorial/:slug" element={<TutorialPage />} />
            <Route path="/bookmarks" element={<BookmarksPage />} />
            <Route path="*" element={<HomePage onOpenSearch={openSearch} />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
